// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import StyledButton from '../../../../../../components/buttons/StyledButton';

// Styles
import './ResetPermissionsLinkWarning.scss';

const ResetPermissionsLinkWarning = (props) => {
    const { onCancel, onConfirm } = props;

    return (
        <div className="ResetPermissionsLinkWarning">
            <h2 className="warning-title">Warning</h2>
            <p className="warning-description">
                Resetting this link will prevent users with the existing link from accessing the board until you share
                the link with them again.
            </p>
            <div className="buttons-container">
                <StyledButton className="primary" onClick={onConfirm}>
                    Reset the link
                </StyledButton>
                <StyledButton className="secondary" onClick={onCancel}>
                    Cancel
                </StyledButton>
            </div>
        </div>
    );
};

ResetPermissionsLinkWarning.propTypes = {
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
};

export default ResetPermissionsLinkWarning;
